import { expVal, expValEquals } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';
import {
	useGetOnboardingState,
	deserializeState,
} from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState';
import {
	LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA,
	FOUNDING_ADMIN_REVAMPED_BPQA_ELIGIBLE,
} from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants';
import { useIsLicensed } from '@confluence/session-data/entry-points/useAccessStatus';

import { isWithinLastWeek } from '../utils/isWithinLastWeek';

export const useShouldShowNewUserTemplates = () => {
	const isLicensed = useIsLicensed();

	const { data, loading, error } = useGetOnboardingState(
		fg('cfind-4971-improved-templates-bar-gate')
			? [
					...Object.values(LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA),
					FOUNDING_ADMIN_REVAMPED_BPQA_ELIGIBLE,
				]
			: [...Object.values(LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA)],
		!isLicensed,
	);
	const { revampedBpqaShownAt, foundingAdminRevampedBpqaEligible } = deserializeState(data);
	const shownAtWithinLastWeek = isWithinLastWeek(revampedBpqaShownAt);

	if (!isLicensed) {
		return { showNewUserTemplates: false, loading: false };
	}

	if (loading) {
		return { showNewUserTemplates: false, loading: true };
	}

	if (error) {
		return { showNewUserTemplates: false, loading: false, error };
	}

	return {
		showNewUserTemplates:
			(foundingAdminRevampedBpqaEligible &&
				expVal('cfind-4971-improved-templates-bar', 'isEnabled', false)) ||
			(shownAtWithinLastWeek &&
				(expValEquals('land_users_in_editor_with_revamped_bpqa_new', 'cohort', 'experiment') ||
					expValEquals(
						'land_users_in_editor_with_revamped_bpqa_existing',
						'cohort',
						'experiment',
					))),
		loading: false,
	};
};
